import {
  Package,
  House,
  Car,
  ChartLine,
  CompassRose,
  Globe,
  CellTower,
  PersonSimple,
  CarProfile,
  GasPump,
  UsersThree,
  Binoculars,
  MapPin,
  Layout,
  Barcode,
  Barricade,
  Wrench,
} from "@phosphor-icons/react";

export const dataSidebar = [
  {
    title: "Gestão Usuários",
    items: [
      {
        name: "Usuários",
        path: "/user-management",
        icon: <UsersThree size={24} />,
        requiresRole: ["admin"],
      },
    ],
  },
  {
    title: "Home",
    items: [
      {
        name: "Home",
        path: "/home",
        icon: <House size={24} />,
        requiresRole: ["admin"],
      },
    ],
  },
  {
    title: "Gestão de pessoas",
    items: [
      {
        name: "Ponto - Residência",
        path: "/ponto-residencia",
        icon: <Binoculars size={24} />,
        requiresRole: ["admin", "rh"],
      },
    ],
  },
  {
    title: "Frota",
    items: [
      {
        name: "Painel",
        path: "/painel-frota",
        icon: <Layout size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Registrar Veículo",
        path: "/register-vehicle",
        icon: <Barcode size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Veículos",
        path: "/table-fleet",
        icon: <Car size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Oficinas",
        path: "/workshops",
        icon: <Wrench size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Manutenção",
        path: "/maintenance-fleet",
        icon: <Barricade size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Localização",
        path: "/rastreio-centro-custo",
        icon: <MapPin size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Preventiva",
        path: "/rastreio-centro-custo",
        icon: <MapPin size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
      {
        name: "Abastecimento",
        path: "/consumo-km-litro",
        icon: <GasPump size={24} />,
        requiresRole: ["admin", "fleet_manager"],
      },
    ],
  },
  {
    title: "TIM TOA",
    items: [
      {
        name: "Visão Geral",
        path: "/view-tasks",
        icon: <Globe size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
      {
        name: "Mapa atividades",
        path: "/map-activities",
        icon: <CompassRose size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
      {
        name: "Indicadores",
        path: "/indicators",
        icon: <ChartLine size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
      {
        name: "Frota",
        path: "/fleettrack",
        icon: <CarProfile size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
      {
        name: "Sites",
        path: "/tim-sites",
        icon: <CellTower size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
      {
        name: "Gestão Ocorrências",
        path: "/tim-ocorrencias",
        icon: <PersonSimple size={24} />,
        requiresRole: ["admin", "tim_toa"],
      },
    ],
  },
  {
    title: "VIVO GENESIS",
    items: [
      {
        name: "Indicadores",
        path: "/vivo-indicadores",
        icon: <Package size={24} />,
        requiresRole: ["admin"],
      },
    ],
  },
];
